import type { Masker } from './mask-object-values'

import { replaceUuids } from './replace-uuids'

export const maskUuids: Masker = (_, value) =>
  typeof value === 'string' ? replaceUuids(value) : value
